import { clientId } from "./constants";

export const knowledgeSpacesRoutes = [
  {
    path: "/knowledge-spaces",
    name: "ksKnowledgeSpaces",
    component: () => import("./views/KnowledgeSpaces.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeSpaces",
          route: { name: "ksKnowledgeSpaces" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/:id",
    name: "ksKnowledgeSpaceDetail",
    props: true,
    component: () => import("./views/KnowledgeSpaceDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeSpaces",
          route: { name: "ksKnowledgeSpaces" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/documents",
    name: "ksKnowledgeDocuments",
    component: () => import("./views/KnowledgeDocuments.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeDocuments",
          route: { name: "ksKnowledgeDocuments" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/documents/:documentId",
    name: "ksDocumentDetails",
    props: true,

    component: () => import("./views/KnowledgeDocumentDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
      ],
    },
  },

  {
    path: "/knowledge-spaces/chats",
    name: "ksChats",
    component: () => import("./views/ChatOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "chats",
          route: { name: "ksChats" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/chat/:id?",
    name: "ksChatDetail",
    props: true,
    component: () => import("./views/ChatDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "chats",
          route: { name: "ksChats" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/:space/chat/:id?",
    name: "ksSpaceChatDetail",
    props: true,
    component: () => import("./views/ChatDetail.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "chats",
          route: { name: "ksChats" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/",
    name: "ksUnits",
    props: true,
    component: () => import("./views/KnowledgeUnits.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/create",
    name: "ksUnitsCreate",
    props: true,
    component: () => import("./views/CreateKnowledgeUnitOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
        {
          label: "createKnowledgeUnit",
          route: { name: "ksUnitsCreate" },
        },
      ],
    },
  },

  {
    path: "/knowledge-spaces/unit-types/",
    name: "ksUnitTypeSelection",
    props: true,
    component: () => import("./views/KnowledgeTwinTypeSelection.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "ksUnitTypeSelection",
          route: { name: "ksUnitTypeSelection" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/:template",
    name: "ksTwinsList",
    props: true,
    component: () => import("./views/KnowledgeTwinOverview.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "ksUnitTypeSelection",
          route: { name: "ksUnitTypeSelection" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/twin/create/:template",
    name: "ksTwinCreate",
    props: true,
    component: () => import("./views/KnowledgeTwinCreate.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/versions/:unitId",
    name: "ksVersionManagement",
    props: true,
    component: () => import("./views/KnowledgeUnitVersionManagement.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
      ],
    },
  },
  {
    path: "/knowledge-spaces/units/twin/edit/:unitId",
    name: "ksTwinEdit",
    props: true,
    component: () => import("./views/KnowledgeTwinEdit.vue"),
    meta: {
      appClientId: clientId,
      breadcrumbs: [
        {
          label: "knowledgeUnits",
          route: { name: "ksUnits" },
        },
      ],
    },
  },
];
